<tt-card *ngIf="!!get">
    <tt-input ttLabel="job_description" [ttModel]="get.note" ttReadonly [ttButtons]="noteButtons"></tt-input>
    <tt-select
        ttLabel="actstatus"
        [(ttModel)]="get.actstatus_keyno"
        (ttModelChange)="onActivityStatusChanged($event)"
        [ttData]="activityStatuses"
        ttDataId="actstatus_keyno"
        ttDataName="actstatus_name"
    ></tt-select>
    <tt-checkbox ttLabel="ok" [(ttModel)]="get.ok"></tt-checkbox>
    <tt-chat [ttOptions]="chatOptions" (change)="submit.emit()"></tt-chat>
</tt-card>
